<div class="flex flex-row flex-auto items-center justify-center before:opacity-10 before:bg-theme-dark before:inset-0 before:absolute">
  <mat-spinner [diameter]="size[spinnerSize]"></mat-spinner>
</div>
